module.exports = __webpack_public_path__ + "img/1995_L.530a720d.png";